export default "https://moinzitechapi.dev-mn.xyz/api/"